import { useGlobalEvent } from '@highlight/ipc/react'
import HighlightLogoIcon from '@renderer/components/Icons/HighlightLogoIcon'
import { InactivityToast } from '../toasts/inactivity-toast'
import { toastManager } from '../toast-store'
import { useToast } from '../use-toast'

type ToastApi = ReturnType<typeof useToast>

const INACTIVITY_TOAST_ID = 'inactivity-prompt'

export function useInactivityToasts(toast: ToastApi) {
  useGlobalEvent('audio-note:inactivity-prompt', (data: { minutes: number }) => {
    toast.add({
      analytics: { type: 'inactivity prompt', minutes: data.minutes },
      id: INACTIVITY_TOAST_ID,
      icon: <HighlightLogoIcon size={24} />,
      title: 'Are you still recording?',
      duration: Infinity,
      autoExpandDelayMs: 0,
      body: (toastId) => <InactivityToast toastId={toastId} minutes={data.minutes} />,
    })
  })

  useGlobalEvent('audio-note:inactivity-prompt-dismiss', () => {
    toastManager.dismiss(INACTIVITY_TOAST_ID)
  })
}
